"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailSentViewContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _view = require("../../actions/view");
var _authentication = require("../../actions/authentication");
var _login = require("../../actions/login");
var _selectors = require("./selectors");
var _events = require("../../actions/events");
var _reactRedux = require("react-redux");
var _EmailSentViewContainer = require("./EmailSentViewContainer");
var _source = require("../../selectors/source");
function mapStateToProps(state) {
  return {
    viewData: (0, _selectors.viewDataSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeView(view) {
      dispatch((0, _view.changeView)(view));
    },
    reset() {
      dispatch((0, _authentication.reset)());
    },
    changeLogin(login) {
      dispatch((0, _login.changeLogin)(login));
    },
    emit(type, event) {
      dispatch((0, _events.emit)(type, event));
    }
  };
}
const EmailSentViewContainer = exports.EmailSentViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EmailSentViewContainer.EmailSentViewContainer);